import Vue from 'vue'
import Router from 'vue-router'
import VideoComponent from './views/VideoComponent'
import UsarCinturon from './views/UsarCinturon'
import RespetarReglas from './views/RespetarReglas'
import ReducirVelocidad from './views/ReducirVelocidad'
import ProtegerNinos from './views/ProtegerNinos'
import PrestarAtencion from './views/PrestarAtencion'
import ManejarDescansado from './views/ManejarDescansado'
import UsarCasco from './views/UsarCasco'
import SerCortes from './views/SerCortes'
import RevisarAuto from './views/RevisarAuto'
import ConsejosAdicionales from './views/ConsejosAdicionales'
import CertificadoGXCV from './views/CertificadoGXCV'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: VideoComponent
    },
    {
      path: '/usar-el-cinturon',
      component: UsarCinturon
    },
    {
      path: '/respetar-las-reglas',
      component: RespetarReglas
    },
    {
      path: '/reducir-la-velocidad',
      component: ReducirVelocidad
    },
    {
      path: '/proteger-a-los-ninos',
      component: ProtegerNinos
    },
    {
      path: '/prestar-atencion',
      component: PrestarAtencion
    },
    {
      path: '/manejar-descansado',
      component: ManejarDescansado
    },
    {
      path: '/usar-casco',
      component: UsarCasco
    },
    {
      path: '/ser-cortes',
      component: SerCortes
    },
    {
      path: '/revisar-el-auto',
      component: RevisarAuto
    },
    {
      path: '/consejos-adicionales',
      component: ConsejosAdicionales
    },
    {
      path: '/certificado-gxsv',
      component: CertificadoGXCV
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('api_token')
  if (!token) {
    if (to.path === '/') {
      next()
    } else {
      next({
        path: '/'
      })
    }
  } else {
    next()
  }
})

export default router
